import { render, staticRenderFns } from "./UnitsSelect.vue?vue&type=template&id=2f2dbeda&"
import script from "./UnitsSelect.vue?vue&type=script&lang=js&"
export * from "./UnitsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports